import React, { Component } from "react";
import { ToastContainer } from "react-toastify";
import { withRouter } from "../../utils/withRouter";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { connect } from "react-redux";
import {
  toastError,
  countryActionId,
  cityActionId,
  industryActionId,
  stateActionId,
  downloadReport,
  sessionExpireMessage,
  tokenInavlidMessage,
} from "../../utils/constants";
import { fill_action } from "../../actions/fillCombo_action";
import Pagination from "../../utils/pagination";
import Header from "../../common_components/Header";
import Loader from "../../utils/Loader";
import { userRegistrationRpt_action } from "../../actions/adminAction/users_action";
import { get_memberDashboardCards_action } from "../../actions/userAction/memberDashboard_action";

class MemberDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      memberCards: [],
      validityMessage: "",
    };
  }

  componentDidMount() {
    if (!JSON.parse(sessionStorage.getItem("loginDataSS"))) {
      setTimeout(() => {
        this.props.navigate("/");
      }, 200);
      return;
    }
    window.scrollTo(0, 0);
    this.getMemberCards();
  }

  getMemberCards() {
    this.setState({ isLoading: true });
    this.props
      .get_memberDashboardCards_action()
      .then((data) => {
        if (data.error != 1) {
          this.setState(
            {
              isLoading: false,
              memberCards: data?.data?.[0],
              validityMessage: data?.data?.[1]?.[0]?.ValidityTillDate,
              PanNo: data?.data?.[1]?.[0]?.PanNo,
              GSTNo: data?.data?.[1]?.[0]?.GSTNo,
              CompanyName: data?.data?.[1]?.[0]?.CompanyName,
            }
          );
        } else {
          if (
            data.msg == sessionExpireMessage ||
            data.msg == tokenInavlidMessage
          ) {
            //after session expire.....................
            sessionStorage.clear();
            this.props.navigate("/");
            setTimeout(() => {
              toastError(data.msg);
            }, 2000);
          } else {
            toastError(data.data);
          }
          this.setState({ isLoading: false });
        }
      })
      .catch((err) => {
        this.setState({ isLoading: false });
        console.log(err);
      });
  }

  onUserRegistrationDownload() {
    this.setState({ isLoading: true });
    const id = sessionStorage.getItem("MemberIDSS");
    this.props
      .userRegistrationRpt_action(id)
      .then((data) => {
        if (data.error != 1) {
          this.setState({ isLoading: false });
          var url = `${downloadReport}?SessionIdentifier=${data}`;
          const win = window.open(url, "_blank");
          if (win != null) {
            win.focus();
          }
        } else {
          if (
            data.msg == sessionExpireMessage ||
            data.msg == tokenInavlidMessage
          ) {
            //after session expire.....................
            sessionStorage.clear();
            this.props.navigate("/");
            setTimeout(() => {
              toastError(data.msg);
            }, 2000);
          } else {
            toastError(data.data);
          }
          this.setState({ isLoading: false });
          toastError(data.msg);
        }
      })
      .catch((err) => {
        this.setState({ isLoading: false });
        console.log(err);
      });
  }
  render() {
    const {
      isLoading,
      memberCards,
      validityMessage,
      creditCard,
      redemptionPoints,
      expiryPoints,
      additionalPoints,
    } = this.state;
    return (
      <>
        {isLoading ? (
          <Loader></Loader>
        ) : (
          <>
            <div className="dashboard-container user-dashboard">
              <div className="dashboard-wrapper">
                <div className="row">
                  <div className="col-md-6">
                    <h1 className="dashboard-heading mt-2">
                      Dashboard
                      <span className="text-dark company-name">
                        <i
                          className="fa fa-building-o"
                          style={{ color: "#be5121" }}
                        ></i>
                        &nbsp; {sessionStorage.getItem("CompanyNameSS")}
                      </span>
                    </h1>
                  </div>
                  <div className="col-md-6">
                    <h5 className="text-end validity-message mt-2 text-danger">
                      {validityMessage ? validityMessage : ""}
                    </h5>
                  </div>
                </div>
                <div className="dashboard-grid">
                  <div
                    className="dashboard-card yellow-border"
                    style={{ justifyContent: "space-around" }}
                  >
                    <div
                      className="dashboard-flex"
                      style={{ justifyContent: "space-between" }}
                    >
                      <div className="dashboard-emoji">
                        <i
                          className="fa fa-file-text-o"
                          style={{ padding: "3px 11px", fontSize: "22px" }}
                        ></i>
                      </div>
                      <h6 className="text-lg ">Registration No</h6>
                    </div>
                    <p className="text-end reg-no">
                      {" "}
                      {sessionStorage.getItem("MembershipNo")}
                    </p>
                  </div>
                  <link
                    rel="stylesheet"
                    href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@24,400,0,0&icon_names=download"
                  />
                  <div
                    className="dashboard-card yellow-border"
                    style={{ justifyContent: "space-around" }}
                  >
                    <div
                      className="dashboard-flex"
                      style={{ justifyContent: "space-between" }}
                    >
                      <div className="dashboard-emoji">
                        <span className="material-symbols-outlined px-2">
                          download
                        </span>
                      </div>
                      <h6 className="text-lg ">Registration Document</h6>
                    </div>
                    <button
                      className="dashboard-button blue-button"
                      onClick={(e) => this.onUserRegistrationDownload()}
                    >
                      {" "}
                      View & Download{" "}
                    </button>
                  </div>
                  {memberCards?.length > 0
                    ? memberCards?.map((card, index) => (
                        <div
                          key={index}
                          className="dashboard-card yellow-border"
                          style={{ justifyContent: "space-around" }}
                        >
                          <div
                            className="dashboard-flex"
                            style={{
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <div className="dashboard-emoji">
                              <span className="material-symbols-outlined px-2">
                                download
                              </span>
                            </div>
                            <div className="d-flex align-items-center">
                              <h6 className="text-lg mb-0">{card.Title}</h6>
                              {card.EventToDate &&
                                new Date(card.EventToDate) > new Date() && (
                                  <span className="newcard-badge">New</span>
                                )}
                            </div>
                          </div>
                          <a
                            className="dashboard-button blue-button"
                            href={card.URL || card.FilePath}
                            target="_blank"
                          >
                            View & Download
                          </a>
                        </div>
                      ))
                    : null}
                </div>
              </div>
            </div>
            <div
              className="modal"
              id="additional_pop"
              tabIndex="-1"
              aria-hidden="true"
            >
              <div className="modal-dialog modal-md">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">
                      Earning Points{" "}
                      <span
                        className="text-success"
                        style={{
                          background: "#eee",
                          padding: "1px 10px",
                          borderRadius: "5px",
                        }}
                      >
                        {creditCard?.AdditionalPoints || 0}
                      </span>
                    </h5>
                    <button
                      type="button"
                      className="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>

                  <div className="modal-body pb-0">
                    <div className="custom_table">
                      <div className="hack1">
                        <div className="hack2">
                          <table className="table table-bordered table-striped mg-b-0">
                            <thead>
                              <tr>
                                <th
                                  className="text-center"
                                  style={{ width: "275px" }}
                                >
                                  Earning Date
                                </th>
                                <th className="text-center">Points</th>
                              </tr>
                            </thead>
                            <tbody id="myTable">
                              {additionalPoints &&
                                additionalPoints.map((item, index) => (
                                  <tr key={index}>
                                    <td className="text-center">
                                      {item.EarningDate}
                                    </td>
                                    <td className="text-center">
                                      {item.Points}
                                    </td>
                                  </tr>
                                ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="modal"
              id="expiring_pop"
              tabIndex="-1"
              aria-hidden="true"
            >
              <div className="modal-dialog modal-md">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">
                      Expiring in next 30 days{" "}
                      <span
                        className="text-danger"
                        style={{
                          background: "#eee",
                          padding: "1px 10px",
                          borderRadius: "5px",
                        }}
                      >
                        {creditCard?.ExpiringInNext30Days || 0}
                      </span>
                    </h5>
                    <button
                      type="button"
                      className="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>

                  <div className="modal-body pb-0">
                    <div className="custom_table">
                      <div className="hack1">
                        <div className="hack2">
                          <table className="table table-bordered table-striped mg-b-0">
                            <thead>
                              <tr>
                                <th
                                  className="text-center"
                                  style={{ width: "275px" }}
                                >
                                  Expiry Date
                                </th>
                                <th className="text-center">Points</th>
                              </tr>
                            </thead>
                            <tbody id="myTable">
                              {expiryPoints &&
                                expiryPoints.map((item, index) => (
                                  <tr key={index}>
                                    <td className="text-center">
                                      {item.ExpiryDate}
                                    </td>
                                    <td className="text-center">
                                      {item.Points}
                                    </td>
                                  </tr>
                                ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="modal"
              id="total_redemption_points_pop"
              tabIndex="-1"
              aria-hidden="true"
            >
              <div className="modal-dialog modal-lg">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">
                      Total Redemption Points{" "}
                      <span
                        className="text-primary"
                        style={{
                          background: "#eee",
                          padding: "1px 10px",
                          borderRadius: "5px",
                        }}
                      >
                        {creditCard?.TotalRedemptionPoints || 0}
                      </span>
                    </h5>
                    <button
                      type="button"
                      className="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                      style={{ fontSize: "13px" }}
                    ></button>
                  </div>

                  <div className="modal-body pb-0">
                    <div className="custom_table">
                      <div className="hack1">
                        <div className="hack2">
                          <table className="table table-bordered table-striped mg-b-0">
                            <thead>
                              <tr>
                                <th style={{ width: "225px" }}>Services</th>
                                <th>Criteria</th>
                                <th className="text-center">Min Points</th>
                                <th className="text-center">Max Points</th>
                                <th style={{ width: "100px" }}></th>
                              </tr>
                            </thead>
                            <tbody id="myTable">
                              {redemptionPoints &&
                                redemptionPoints.map((item, index) => (
                                  <tr key={index}>
                                    <td>{item.Service}</td>
                                    <td>{item.Criteria}</td>
                                    <td className="text-center">
                                      {item.MinPoints}
                                    </td>
                                    <td className="text-center">
                                      {item.MaxPoints}
                                    </td>
                                    <td className="text-center">
                                      <button
                                        type="button"
                                        className="btn"
                                        style={{
                                          border: "1px solid purple",
                                          color: "purple",
                                          background: "transparent",
                                          borderRadius: "5px",
                                          padding: "2px 10px",
                                        }}
                                      >
                                        Redeem
                                      </button>
                                    </td>
                                  </tr>
                                ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
        <Header />
        <ToastContainer />
      </>
    );
  }
}

export default withRouter(
  connect(null, {
    fill_action,
    userRegistrationRpt_action,
    get_memberDashboardCards_action,
  })(MemberDashboard)
);
